module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/BelowDeckMed_S4.fe76cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/BelowDeckMed_S4.jpg
// module id = TKCV
// module chunks = 0